// extracted by mini-css-extract-plugin
export default {"content":"DeleteUserModal_content__6fc5W","icon":"DeleteUserModal_icon__b-+Gw","info":"DeleteUserModal_info__kcFcF","buttonRow":"DeleteUserModal_buttonRow__CUcS3"};